/* =================== MÁSCARAS DOS CAMPOS =================== */

// SOMENTE NÚMERO
$(".number").each(function() {
  $(this).on("keyup keydown keypress", function() {
    $(this).val(
      $(this)
        .val()
        .replace(/\D/g, "")
    );
  });
});

// VALOR
/* $('.valor').mask('000.000.000.000.000,00', {reverse: true}); */
$(".valor")
  .maskMoney({
    prefix: "R$ ",
    thousands: ".",
    decimal: ","
  })
  .on("change", function() {
    $(this)
      .parsley()
      .validate();
  });

// CEP
$(".cep").mask("00000-000");

// DATA
$(".data").mask("00/00/0000");

// CPF
$(".cpf").mask("000.000.000-00", { reverse: true });

// CNPJ
$(".cnpj").mask("00.000.000/0000-00", { reverse: true });

// CPF OU CNPJ
var cpfCnpj = function(val) {
    return val.length > 14 ? "00.000.000/0000-00" : "000.000.000-009";
  },
  optionsDocumento = {
    onKeyPress: function(val, e, field, options) {
      field.mask(cpfCnpj(val), options);
    }
  };
$(".cpf-cnpj").mask(cpfCnpj, optionsDocumento);

// TELEFONE
var telefoneSP = function(val) {
    return val.replace(/\D/g, "").length === 11
      ? "(00) 00000-0000"
      : "(00) 0000-00009";
  },
  spOptions = {
    onKeyPress: function(val, e, field, options) {
      field.mask(telefoneSP.apply({}, arguments), options);
    }
  };
$(".telefone").mask(telefoneSP, spOptions);

// CARTÃO DE CRÉDITO
$(".card-numero").mask("0000 0000 0000 0000", { reverse: true });

// CARTÃO DE CRÉDITO (VALIDADE)
$(".card-validade").mask("00/00");

const flatpickrPtBr = {
  weekdays: {
    shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    longhand: [
      "Domingo",
      "Segunda-feira",
      "Terça-feira",
      "Quarta-feira",
      "Quinta-feira",
      "Sexta-feira",
      "Sábado"
    ]
  },
  months: {
    shorthand: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ],
    longhand: [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ]
  },
  rangeSeparator: " até "
};

// DATEPICKER (https://flatpickr.js.org)
// Datepicker
$(".datepicker").flatpickr({
  dateFormat: "d/m/Y",
  //defaultDate: "today",
  disableMobile: "true",
  locale: flatpickrPtBr
});
// Timepicker
$(".timepicker").flatpickr({
  enableTime: true,
  noCalendar: true,
  dateFormat: "H:i",
  time_24hr: true,
  disableMobile: "false",
  locale: flatpickrPtBr
});
// Datepicker + Timepicker
$(".datetimepicker").flatpickr({
  dateFormat: "d/m/Y H:i",
  disableMobile: "true",
  enableTime: true,
  locale: flatpickrPtBr
});

// Range
$(".campo-range").each(function() {
  const min = Number($(this).attr("min"));
  const max = Number($(this).attr("max"));
  const handle = $(this).find(".ui-slider-handle");
  const input = $(this).find("input");
  $(this).slider({
    range: false,
    min: min,
    max: max,
    create: function() {
      handle.text($(this).slider("value"));
    },
    slide: function(event, ui) {
      handle.text(ui.value);
      input.val(ui.value);
    }
  });
});

// Select 2
if ($(".select-multiple").length > 0) {
  $(".select-multiple").select2({
    placeholder: "Selecione",
    width: "100%",
    language: "pt-BR"
  });
  $(".select-multiple").on("change", function(e) {
    $(this)
      .parsley()
      .validate();
  });
}

$(".campo_status").on("change", verificaCampoStatus);
function verificaCampoStatus() {
  $(".campo_status").each(function() {
    if ($(this).val() != "") {
      $(this)
        .removeClass("status_0 status_1 status_2")
        .addClass("status_" + $(this).val());
    }
  });
}
verificaCampoStatus();
